module.exports = __webpack_public_path__ + "img/Solution3.625a9545.png";